import epgRequest from '~/src/api/requests/epgRequest';
import profileRequest from '@ertelecom/ui-react/components/requests/profileRequest';

/**
 * Получение каналов из EPG
 * @param {string} citydomain
 * @param {int} packageId
 * @returns {Promise}
 */
export function getPackageChannels(citydomain, packageId) {
    return epgRequest.getWithCache('/channel/list', {
        params: {
            bid: packageId,
            domain: citydomain
        }
    }).then(response => {
        return response.data.map(channel => {
            channel.logo = process.env.EPG_API_ENDPOINT + channel.logo;
            return channel;
        });
    });
}

/**
 * Перевод СП на следующий шаг
 * @param {object} city
 * @param {int} offerId
 * @param {int} currentStep
 * @param {number} child
 * @param {string} accessToken
 * @returns {Promise}
 */
export function pushOfferToNextStep(city, offerId, currentStep, child, accessToken) {
    const params = {
        currentStep,
        child
    };
    return profileRequest(city.domain, accessToken, city.billingHost).put('/spec-offers/' + offerId, params);
}

/**
 * Получить акции
 * @param {object} city
 * @param {string} accessToken
 * @returns {Promise}
 */
export function getPromo(city, accessToken) {
    return profileRequest(city.domain, accessToken, city.billingHost).get('/spec-offer-promo');
}

/**
 * Получить акции и подарки
 * @param {string} city
 * @param {string} accessToken
 * @returns {Promise}
 */
export function getAllOffers(city, accessToken) {
    return profileRequest(city, accessToken).get('/spec-offer');
}

/**
 * Получить оффер по id
 * @param {string} city
 * @param {string} accessToken
 * @param {integer} offerId
 * @returns {Promise}
 */
export function getSingleOffer(city, accessToken, offerId) {
    return profileRequest(city, accessToken).get(`/spec-offer/view?id=${offerId}`);
}
